import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

import { HdsAlert } from '@hashicorp/design-system-components/components';
import type { HdsAlertSignature } from '@hashicorp/design-system-components/components/hds/alert/index';

interface ContactSalesSignature {
  Element: HdsAlertSignature['Element'];
}

<template>
  <HdsAlert @type="inline" ...attributes data-test-contact-sales as |A|>
    <A.Description data-test-contact-sales-description>
      {{t "billing-common.common.eu.alert.description"}}
    </A.Description>
    <A.Button
      @text={{t "billing-common.common.eu.alert.contact-sales.link-text"}}
      @href={{t "billing-common.common.eu.alert.contact-sales.link-href"}}
      @icon="external-link"
      @iconPosition="trailing"
      @isHrefExternal={{true}}
      @color="secondary"
      data-test-contact-sales-button
    />
  </HdsAlert>
</template> satisfies TOC<ContactSalesSignature>;
